import {
  Button,
  ButtonGroup,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Stack,
} from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { useState } from 'react';

import { EventsTab } from './EventsTab';
import { ShipmentFormTab } from './ShipmentFormTab';
import { SubscribersTab } from './SubscribersTab';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const ShipmentDrawer = ({ isOpen, onClose }: Props) => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (nextTabIndex: number) => () => {
    setTabIndex(nextTabIndex);
  };

  return (
    <Drawer size="lg" placement="right" onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerHeader px="4">
          <Stack>
            <Stack direction="row" spacing={4} w="full" justify="start">
              <DrawerCloseButton />
            </Stack>
            <ButtonGroup size="sm" isAttached>
              <Button
                variant={tabIndex === 0 ? 'solid' : 'outline'}
                colorScheme={tabIndex === 0 ? 'secondary' : 'gray'}
                onClick={handleTabChange(0)}
              >
                Events
              </Button>
              <Button
                variant={tabIndex === 1 ? 'solid' : 'outline'}
                colorScheme={tabIndex === 1 ? 'secondary' : 'gray'}
                onClick={handleTabChange(1)}
              >
                Subscribers
              </Button>
              <Button
                variant={tabIndex === 2 ? 'solid' : 'outline'}
                colorScheme={tabIndex === 2 ? 'secondary' : 'gray'}
                onClick={handleTabChange(2)}
              >
                Add Shipment
              </Button>
            </ButtonGroup>
          </Stack>
        </DrawerHeader>
        <Show if={tabIndex === 0}>
          <EventsTab />
        </Show>
        <Show if={tabIndex === 1}>
          <SubscribersTab />
        </Show>
        <Show if={tabIndex === 2}>
          <ShipmentFormTab />
        </Show>
      </DrawerContent>
    </Drawer>
  );
};
